<template>
  <a :href="basketUrl"
     class="cta cta--primary--alt mini-basket">
    <font-awesome-icon :icon="['fal', 'shopping-basket']"></font-awesome-icon>
    <basket-item-quantity v-model="count"
                          class="mini-basket__count">
    </basket-item-quantity>
  </a>
</template>

<script>
import { BasketItemQuantity } from "spiritweb.packages.ecommerce";

export default {
  name: "MiniBasket",
  components: {
    BasketItemQuantity,
  },
  props: {
    basketUrl: {
      type: String,
      default: "/",
    },
  },
  data () {
    return {
      count: 20,
    };
  },
};
</script>

<style lang="less" scoped>
.mini-basket {
  margin-left: 10px;
  color: #fff !important;
  min-width: auto;
  border: none;

  @media ( max-width: 1199px ) {
    width: calc( 100% - 20px );
    margin: 0 10px;
  }
}
</style>
